<template>
  <LayoutDashboard title="Etiquetas">
    <v-card outlined>
      <v-card-title>
        <v-btn
          color="primary"
          @click="cadastrarEtiqueta"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-etiqueta')"
          class="mr-1 ml-1"
          >Cadastrar</v-btn
        >
        <v-btn
          color="success"
          @click="setModalImprimirEtiqueta(true)"
          outlined
          dense
          class="mr-1 ml-1"
          >Imprimir</v-btn
        >
        <v-spacer></v-spacer>
        <v-text-field
          outlined
          dense
          v-model="search"
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
        >
        </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="getEtiquetas"
          :search="search"
          dense
        >
          <template v-slot:item.action="{ item }">
            <v-btn
              color="primary"
              outlined
              small
              @click="visualizarEtiqueta(item)"
              v-if="$helper.verificaPermissao('visualizar-etiqueta')"
              >Visualizar</v-btn
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <ModalCadastroEtiqueta />
    <ModalImprimirEtiqueta />
  </LayoutDashboard>
</template>

<script>
import ModalCadastroEtiqueta from "@/pages/etiqueta/ModalCadastro";
import ModalImprimirEtiqueta from "@/pages/etiqueta/ModalImprimirEtiqueta";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ModalCadastroEtiqueta,
    ModalImprimirEtiqueta,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "#", value: "id" },
        { text: "Etiqueta", value: "nome" },
        { text: "", value: "action", sortable: false },
      ],
      funcionarios: [],
    };
  },
  computed: {
    ...mapGetters(["getEtiquetas"]),
  },
  methods: {
    ...mapActions([
      "listarEtiquetas",
      "visualizarEtiqueta",
      "cadastrarEtiqueta",
      "setModalImprimirEtiqueta",
    ]),
  },
  created() {
    this.listarEtiquetas();
  },
};
</script>
